@if (store.selectedTable) {
  <div class="admin-import-module__section admin-import-module__section--full">
    @if (store.profileRestoreWarnings.length) {
      <div class="admin-import-module__warn admin-import-module__profile-restore-warnings">
        <p class="bold">{{ 'TRANS__IMPORT__PROFILE__RESTORE__SOME_MISSING' | translate }}</p>
        <ul>
          @for (warning of store.profileRestoreWarnings; track $index) {
            <li>{{ warning }}</li>
          }
        </ul>
      </div>
    }
    @if (store.loadingColumns || store.loadingTargetFields) {
      <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
    }
    @if (!store.loadingColumns && !store.loadingTargetFields && store.columns.length) {
      <div class="admin-import-module__mapping">

        <mat-card
          appearance="outlined"
          class="admin-import-module__pane admin-import-module__columns"
          role="region"
          aria-labelledby="import-mapping-columns-heading"
        >
          <div class="admin-import-module__pane-head">
            <h4 id="import-mapping-columns-heading">{{ 'TRANS__IMPORT__SOURCE_COLUMNS' | translate }}</h4>
            <span class="admin-import-module__column-count">{{ store.columns.length }}</span>
          </div>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="admin-import-module__column-query">
            <mat-icon matPrefix>search</mat-icon>
            <mat-label>{{ 'TRANS__IMPORT__MAPPING__COLUMN_QUERY' | translate }}</mat-label>
            <input type="text" matInput [formControl]="columnQueryControl">
          </mat-form-field>
          @let usedCount = usedColumnCount;
          <mat-button-toggle-group
            class="admin-import-module__column-filter"
            hideSingleSelectionIndicator
            [attr.aria-label]="'TRANS__IMPORT__MAPPING__COLUMN_FILTER' | translate"
            [value]="columnFilter"
            (change)="columnFilter = $event.value"
          >
            <mat-button-toggle value="all">
              {{ 'TRANS__IMPORT__MAPPING__COLUMN_FILTER_ALL' | translate: {count: store.columns.length} }}
            </mat-button-toggle>
            <mat-button-toggle value="unused">
              {{ 'TRANS__IMPORT__MAPPING__COLUMN_FILTER_UNUSED' | translate: {count: store.columns.length - usedCount} }}
            </mat-button-toggle>
            <mat-button-toggle value="used">
              {{ 'TRANS__IMPORT__MAPPING__COLUMN_FILTER_USED' | translate: {count: usedCount} }}
            </mat-button-toggle>
          </mat-button-toggle-group>
          <ul class="admin-import-module__column-list">
            @for (col of shownColumns; track col.name) {
              @let expanded = expandedColumn === col.name;
              @let detailsId = 'admin-import-module-column-details-' + $index;
              <li
                class="admin-import-module__column"
                [class.admin-import-module__column--unused]="!col.used"
                [class.admin-import-module__column--blank]="col.blank"
                [class.admin-import-module__column--expanded]="expanded"
              >
                <!-- The whole item opens and closes the column's details. -->
                <button
                  type="button"
                  class="admin-import-module__column-head"
                  [attr.aria-expanded]="expanded"
                  [attr.aria-controls]="expanded ? detailsId : null"
                  (click)="toggleColumn(col.name)"
                >
                  <span class="admin-import-module__column-dot" aria-hidden="true"></span>
                  <span class="admin-import-module__col-name">{{ col.name }}</span>
                  <span class="admin-import-module__column-marks">
                    @if (col.blank) {
                      <span class="admin-import-module__column-state">
                        {{ 'TRANS__IMPORT__MAPPING__COLUMN_BLANK' | translate }}
                      </span>
                    }
                    @if (col.used) {
                      <span class="admin-import-module__column-uses">{{ col.targets.length }}</span>
                    } @else if (!col.blank) {
                      <span class="admin-import-module__column-state admin-import-module__column-state--unused">
                        {{ 'TRANS__IMPORT__MAPPING__COLUMN_UNUSED' | translate }}
                      </span>
                    }
                  </span>
                  @if (!expanded) {
                    <span class="admin-import-module__column-summary">
                      @if (col.used) {
                        <span aria-hidden="true">→ </span>
                        @for (target of col.summaryTargets; track $index) {
                          <span>{{ $first ? '' : '; ' }}{{ targetText(target) }}</span>
                        }
                      } @else if (col.blank && col.profile) {
                        {{ 'TRANS__IMPORT__MAPPING__COLUMN_BLANK_ALL' | translate: {count: col.profile.empty} }}
                      } @else {
                        {{ col.valuesText }}
                      }
                    </span>
                  }
                </button>
                @if (expanded) {
                  <div class="admin-import-module__column-details" [id]="detailsId">
                    @if (col.targets.length) {
                      <div class="admin-import-module__column-targets">
                        @for (target of col.targets; track $index) {
                          <span class="admin-import-module__column-target">
                            <span aria-hidden="true">→</span> {{ targetText(target) }}
                          </span>
                        }
                      </div>
                    }
                    @if (col.profile; as profile) {
                      @if (col.blank) {
                        <span class="admin-import-module__column-summary">
                          {{ 'TRANS__IMPORT__MAPPING__COLUMN_BLANK_ALL' | translate: {count: profile.empty} }}
                        </span>
                      } @else {
                        <span class="admin-import-module__column-stats">
                          <span>{{ 'TRANS__IMPORT__MAPPING__COLUMN_FILLED' | translate: {count: profile.filled} }}</span>
                          <span>{{ 'TRANS__IMPORT__MAPPING__COLUMN_EMPTY' | translate: {count: profile.empty} }}</span>
                          <span>{{ 'TRANS__IMPORT__MAPPING__COLUMN_DISTINCT' | translate: {count: distinctText(profile)} }}</span>
                        </span>
                      }
                    }
                    @for (suggestion of col.suggestions; track suggestion.value) {
                      <div class="admin-import-module__column-suggestion">
                        <span class="admin-import-module__column-suggestion-head">
                          <mat-icon aria-hidden="true">lightbulb</mat-icon>
                          <span>
                            <b>«{{ suggestion.value }}»</b>
                            {{ suggestionKey(suggestion.count) | translate: {count: suggestion.count} }}
                          </span>
                        </span>
                        <span class="admin-import-module__column-consequence">
                          @if (suggestion.term) {
                            {{ 'TRANS__IMPORT__BLANK_VALUES__LIKELY_REAL' | translate }}
                          } @else {
                            @for (phrase of suggestion.consequences; track $index) {
                              {{ phrase.key | translate: phrase.params }}
                            }
                          }
                        </span>
                        <!-- A likely real value makes Nei the primary action. -->
                        <div class="admin-import-module__column-suggestion-actions">
                          <button type="button" color="primary"
                                  [matButton]="suggestion.term ? 'outlined' : 'filled'"
                                  class="admin-import-module__column-means-blank"
                                  (click)="store.markBlankValue(col.name, suggestion.value)">
                            <span class="bold uppercase">{{ 'TRANS__IMPORT__BLANK_VALUES__MEANS_BLANK' | translate }}</span>
                          </button>
                          <button type="button" color="primary"
                                  [matButton]="suggestion.term ? 'filled' : 'text'"
                                  class="admin-import-module__column-real-value"
                                  (click)="store.rejectBlankValue(col.name, suggestion.value)">
                            <span class="bold uppercase">{{ 'TRANS__IMPORT__MAPPING__COLUMN_SUGGESTION_NO' | translate }}</span>
                          </button>
                        </div>
                      </div>
                    }
                    @if (col.profile) {
                      @if (col.topValues.length) {
                        <div class="admin-import-module__column-values">
                          <span class="admin-import-module__column-caption">
                            {{ 'TRANS__IMPORT__MAPPING__COLUMN_TOP_VALUES' | translate }}
                          </span>
                          @for (top of col.topValues; track top.value) {
                            <span class="admin-import-module__column-value">
                              <span class="admin-import-module__column-value-text">{{ top.value }}</span>
                              @if (top.readAsBlank) {
                                <span class="admin-import-module__column-read-as-blank">
                                  {{ 'TRANS__IMPORT__MAPPING__COLUMN_READ_AS_BLANK' | translate }}
                                </span>
                              }
                              <span class="admin-import-module__column-value-count">{{ top.count }}</span>
                            </span>
                          }
                        </div>
                      }
                    } @else if (col.samples.length) {
                      <div class="admin-import-module__column-values">
                        <span class="admin-import-module__column-caption">
                          {{ 'TRANS__IMPORT__MAPPING__COLUMN_SAMPLES' | translate }}
                        </span>
                        @for (sample of col.samples; track $index) {
                          <span class="admin-import-module__column-value">
                            <span class="admin-import-module__column-value-text">{{ sample }}</span>
                          </span>
                        }
                      </div>
                    }
                    <button
                      mat-stroked-button
                      color="primary"
                      type="button"
                      class="admin-import-module__column-add"
                      [matTooltip]="'TRANS__IMPORT__MAPPING__COLUMN_ADD_LINE' | translate: {column: col.name}"
                      (click)="addColumnRow(col.name)"
                    >
                      <mat-icon>add</mat-icon>
                      <span class="bold uppercase">{{ 'TRANS__IMPORT__MAPPING__ADD_FIELD' | translate }}</span>
                    </button>
                  </div>
                }
              </li>
            } @empty {
              <li class="admin-import-module__column-none">
                {{ 'TRANS__IMPORT__MAPPING__COLUMN_NONE' | translate }}
              </li>
            }
          </ul>
        </mat-card>

        <mat-card
          appearance="outlined"
          class="admin-import-module__pane admin-import-module__assignments"
          role="region"
          aria-labelledby="import-mapping-target-heading"
        >
          <div class="admin-import-module__pane-head">
            <h4 id="import-mapping-target-heading">{{ 'TRANS__IMPORT__MAPPING__TARGET_HEADING' | translate }}</h4>
            <span class="admin-import-module__line-count">{{ store.lineCount }}</span>
            <button
              mat-stroked-button
              type="button"
              class="admin-import-module__add-field"
              [disabled]="addSearchOpen"
              (click)="openAddSearch()"
            >
              <mat-icon>add</mat-icon>
              <span class="bold uppercase">{{ 'TRANS__IMPORT__MAPPING__ADD_FIELD' | translate }}</span>
            </button>
          </div>

          @if (addSearchOpen) {
            @let matches = addSearchMatches;
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="admin-import-module__add-search">
              <mat-icon matPrefix>search</mat-icon>
              <mat-label>{{ 'TRANS__IMPORT__MAPPING__ADD_SEARCH' | translate }}</mat-label>
              <input
                #addSearchInput
                type="text"
                matInput
                [formControl]="addSearchControl"
                [matAutocomplete]="addSearchAuto"
                (keydown.escape)="closeAddSearch()"
              >
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="closeAddSearch()"
                [attr.aria-label]="'TRANS__IMPORT__MAPPING__ADD_SEARCH_CLOSE' | translate"
              >
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete
                #addSearchAuto="matAutocomplete"
                [displayWith]="displayAddSearchPick"
                (optionSelected)="onAddSearchPicked($event)"
              >
                @for (section of matches; track section.key) {
                  <mat-optgroup>
                    <span class="admin-import-module__add-group-title">{{ section.titleKey | translate }}</span>
                    @for (match of section.lines; track addSearchTrackKey(match.option)) {
                      <mat-option [value]="match.option" class="admin-import-module__add-option">
                        <span class="admin-import-module__add-option-label">{{ match.before }}<b>{{ match.match }}</b>{{ match.after }}</span>
                        @if (match.option.cfg) {
                          <span class="admin-import-module__add-option-note">
                            @if (match.option.createsMissing) {
                              {{ 'TRANS__IMPORT__MAPPING__ADD_SEARCH_GROUP_CREATES_MISSING' | translate }}
                            } @else {
                              {{ 'TRANS__IMPORT__MAPPING__ADD_SEARCH_GROUP' | translate }}
                            }
                          </span>
                        } @else if (match.typeKey) {
                          <span class="admin-import-module__add-option-note">{{ match.typeKey | translate }}</span>
                        }
                      </mat-option>
                    }
                  </mat-optgroup>
                } @empty {
                  <mat-option disabled>{{ 'TRANS__IMPORT__MAPPING__ADD_SEARCH_NO_MATCH' | translate }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }

          @if (store.requiredBatchPickMissing) {
            <button
              mat-button
              type="button"
              class="admin-import-module__batch-missing"
              (click)="showBatchBlock()"
            >
              <mat-icon>warning_amber</mat-icon>
              {{ 'TRANS__IMPORT__MAPPING__BATCH_PICK_MISSING' | translate }}
            </button>
          }

          @let preview = store.livePreview;
          @if (store.lineCount) {
            <div class="admin-import-module__target-columns">
              <span>{{ 'TRANS__IMPORT__MAPPING__COL_FIELD' | translate }}</span>
              <span>{{ 'TRANS__IMPORT__MAPPING__COL_SOURCE' | translate }}</span>
              @if (preview) {
                <span class="admin-import-module__target-columns-row">
                  {{ 'TRANS__IMPORT__LIVE_PREVIEW__ROW_COLUMN' | translate: {row: preview.row} }}
                </span>
              }
            </div>
          } @else {
            <p class="admin-import-module__hint">{{ 'TRANS__IMPORT__MAPPING__EMPTY_HINT' | translate }}</p>
          }

          <div class="admin-import-module__target-list">
          @for (section of store.targetSections; track section.key) {
            <div class="admin-import-module__target-section">
              <h6 class="admin-import-module__target-section-title">{{ section.titleKey | translate }}</h6>
              @for (entry of section.lines; track entry.card ?? entry.row) {
                @if (entry.card; as model) {
                  @let cfg = entry.cfg!;
                  @if (cfg.hintKey && store.openedLine === model) {
                    <p class="admin-import-module__hint">{{ cfg.hintKey | translate }}</p>
                  }
                  <app-group-card
                    [descriptor]="store.groupDescriptors[cfg.kind]"
                    [model]="model"
                    [index]="entry.index"
                    [columns]="store.columns"
                    [lookups]="store.groupLookups(cfg.kind)"
                    [lookupColumns]="store.lookupColumns"
                    [lookupColumnsLoading]="store.lookupColumnsLoading"
                    [opened]="store.openedLine === model"
                    [class.admin-import-module__opened-line]="store.openedLine === model"
                    [incomplete]="store.isLineIncomplete(model)"
                    [missingMembers]="store.missingRequiredMembers(model)"
                    [mappingVersion]="store.currentMappingVersion"
                    [previewRow]="preview?.row ?? null"
                    [preview]="store.livePreviewCard(model)"
                    [previewPending]="store.livePreviewPending"
                    (openedChange)="$event ? store.openLine(model) : store.closeLine(model)"
                    (addMember)="store.addGroupMember(model, $event)"
                    (removeMember)="store.removeGroupMember(model, $event)"
                    (addSubBlock)="store.addGroupSubBlock(model, $event)"
                    (removeSubBlock)="store.removeGroupSubBlock(model, $event)"
                    (removeGroup)="store.removeGroupOfKind(cfg.kind, model)"
                    (addComposeLine)="store.addComposeLine($event.row, $event.column)"
                    (removeComposeLine)="store.removeComposeLine($event.row, $event.line)"
                    (reorderComposeLines)="store.reorderComposeLines($event.row, $event.lines)"
                  ></app-group-card>
                } @else if (entry.row; as a) {
                  @if (store.openedLine === a) {
                    <div class="admin-import-module__assignment admin-import-module__assignment--opened admin-import-module__opened-line">
                      @let kind = store.sourceKind(a);
                      <div class="admin-import-module__assignment-row">
                        <mat-form-field
                          appearance="outline"
                          subscriptSizing="dynamic"
                          class="admin-import-module__target"
                        >
                          <mat-label>{{ 'TRANS__IMPORT__COL__TARGET' | translate }}</mat-label>
                          <input
                            #targetInput
                            type="text"
                            matInput
                            [formControl]="a.targetFieldControl"
                            [matAutocomplete]="auto"
                            (focus)="onTargetFocus(a)"
                            (blur)="onTargetBlur(a, auto.isOpen)"
                          >
                          <mat-autocomplete
                            #auto="matAutocomplete"
                            [displayWith]="displayTargetField"
                            (closed)="onTargetListClosed(a, targetInput)"
                          >
                            <!-- See `targetOptionsRowId`. -->
                            @if (targetOptionsRowId === a.id) {
                              @for (field of a.filteredTargetFields; track field.field_id) {
                                <mat-option [value]="field">{{ field.label }}</mat-option>
                              }
                            }
                          </mat-autocomplete>
                        </mat-form-field>

                        <span class="admin-import-module__assignment-eq">←</span>

                        <mat-form-field
                          appearance="outline"
                          subscriptSizing="dynamic"
                          class="admin-import-module__source-kind"
                        >
                          <mat-label>{{ 'TRANS__IMPORT__VALUE_SOURCE' | translate }}</mat-label>
                          <mat-select
                            [value]="kind"
                            (selectionChange)="store.setSourceKind(a, $event.value)"
                            [aria-describedby]="'import-source-hint-' + a.id"
                          >
                            @for (option of sourceKinds(a, kind); track option) {
                              <mat-option
                                [value]="option"
                                [matTooltip]="sourceKindTooltips[option] | translate"
                                matTooltipPosition="right"
                              >{{ sourceKindLabels[option] | translate }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>

                        @if (kind === 'column') {
                          <app-column-template-input
                            class="admin-import-module__template"
                            [control]="a.templateControl"
                            [columns]="store.columns"
                          ></app-column-template-input>
                        } @else if (kind === 'constant') {
                          <mat-form-field
                            appearance="outline"
                            subscriptSizing="dynamic"
                            class="admin-import-module__template"
                          >
                            <mat-label>{{ 'TRANS__IMPORT__GROUP_CARD__FIXED_VALUE' | translate }}</mat-label>
                            <input matInput [formControl]="a.templateControl">
                          </mat-form-field>
                        } @else if (kind === 'lookup') {
                          <app-lookup-source-fields
                            [row]="a"
                            [lookups]="store.lookupDefinitions"
                            [lookupColumns]="store.lookupColumns"
                            [lookupColumnsLoading]="store.lookupColumnsLoading"
                          ></app-lookup-source-fields>
                        }

                        <button
                          mat-icon-button
                          type="button"
                          (click)="store.removeAssignment(a)"
                          [attr.aria-label]="'TRANS__IMPORT__REMOVE_MAPPING' | translate"
                        >
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                      <p class="admin-import-module__hint admin-import-module__source-hint" [id]="'import-source-hint-' + a.id">
                        {{ sourceKindTooltips[kind] | translate }}
                      </p>

                      @if (a.conceptRootOptions.length) {
                        <div class="admin-import-module__concept-root">
                          <app-concept-picker
                            label="TRANS__IMPORT__CONCEPT_ROOT_SCOPE"
                            [required]="false"
                            [options]="a.conceptRootOptions"
                            [control]="a.conceptRootControl"
                          ></app-concept-picker>
                          <mat-icon
                            class="admin-import-module__help"
                            [matTooltip]="'TRANS__IMPORT__CONCEPT_ROOT_SCOPE_TOOLTIP' | translate"
                            matTooltipPosition="right"
                          >help_outline</mat-icon>
                        </div>
                      }

                      @if (kind === 'compose') {
                        <app-compose-field
                          [rows]="a.composeRows"
                          [columns]="store.columns"
                          (addLine)="store.addComposeLine(a)"
                          (removeLine)="store.removeComposeLine(a, $event)"
                          (reorder)="store.reorderComposeLines(a, $event)"
                        ></app-compose-field>
                      }

                      @let openedValues = store.livePreviewLineValues(a);
                      @if (preview && openedValues) {
                        <p class="admin-import-module__row-value-line">
                          <app-row-value
                            [values]="openedValues"
                            [labelRow]="preview.row"
                            [pending]="store.livePreviewPending"
                          ></app-row-value>
                        </p>
                      }
                      @if (store.placeholderWarning(a); as unknown) {
                        @if (unknown.length) {
                          <p class="admin-import-module__warn">
                            {{ 'TRANS__IMPORT__UNKNOWN_PLACEHOLDER' | translate }}:
                            {{ unknown.join(', ') }}
                          </p>
                        }
                      }
                      @if (kind === 'constant') {
                        @if (store.lineIssue(a); as issue) {
                          <p class="admin-import-module__warn admin-import-module__fixed-reads-column">
                            {{ issue.key | translate: issue.params }}
                          </p>
                        }
                      }

                      <div class="admin-import-module__line-actions">
                        <button mat-flat-button color="primary" type="button" (click)="store.closeLine(a)">
                          <span class="bold uppercase">{{ 'TRANS__IMPORT__LINE__DONE' | translate }}</span>
                        </button>
                      </div>
                    </div>
                  } @else {
                    @let lineLabel = a.targetField?.label || ('TRANS__IMPORT__COL__TARGET' | translate);
                    @let sourcePieces = store.sourceSummary(a);
                    @let composeLines = composeLinesOf(sourcePieces);
                    <div
                      class="admin-import-module__line"
                      [class.admin-import-module__line--lines]="composeLines"
                      [class.admin-import-module__line--lines-valued]="composeLines && preview"
                    >
                      <span class="admin-import-module__line-label">{{ lineLabel }}</span>
                      <span class="admin-import-module__line-source">
                        <app-source-pieces
                          [fixedValue]="store.sourceKind(a) === 'constant' ? a.templateControl.value : null"
                          [pieces]="composeLines ? composeLines.mark : sourcePieces"
                        ></app-source-pieces>
                      </span>
                      @if (a.conceptRootControl.value) {
                        <span class="admin-import-module__line-scope">
                          @if (rootScopeName(a); as rootName) {
                            {{ 'TRANS__IMPORT__LINE__ROOT_SCOPE' | translate: {name: rootName} }}
                          } @else {
                            {{ 'TRANS__IMPORT__LINE__ROOT_SCOPED' | translate }}
                          }
                        </span>
                      }
                      @if (store.lineIssue(a); as issue) {
                        <span class="admin-import-module__line-warn">
                          <mat-icon aria-hidden="true">warning_amber</mat-icon>
                          {{ issue.key | translate: issue.params }}
                        </span>
                      }
                      @if (preview) {
                        @let lineValues = store.livePreviewLineValues(a);
                        <span class="admin-import-module__line-value">
                          @if (lineValues !== undefined) {
                            <app-row-value [values]="lineValues" [pending]="store.livePreviewPending"></app-row-value>
                          }
                        </span>
                      }
                      <button
                        mat-icon-button
                        type="button"
                        class="admin-import-module__line-open"
                        (click)="store.openLine(a)"
                        [matTooltip]="'TRANS__IMPORT__LINE__EDIT' | translate: {field: lineLabel}"
                        [attr.aria-label]="'TRANS__IMPORT__LINE__EDIT' | translate: {field: lineLabel}"
                      >
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        type="button"
                        class="admin-import-module__line-remove"
                        (click)="store.removeAssignment(a)"
                        [matTooltip]="'TRANS__IMPORT__REMOVE_MAPPING' | translate"
                        [attr.aria-label]="'TRANS__IMPORT__REMOVE_MAPPING' | translate"
                      >
                        <mat-icon>delete_outline</mat-icon>
                      </button>
                      @if (composeLines) {
                        @for (line of composeLines.lines; track $index) {
                          <span class="admin-import-module__line-source">
                            <span class="admin-import-module__line-item">
                              <span class="admin-import-module__line-item-label">
                                {{ 'TRANS__IMPORT__MAPPING__COMPOSE_LINE' | translate: {number: $index + 1} }}
                              </span>
                              <app-source-pieces [pieces]="line" [keepColumns]="true"></app-source-pieces>
                            </span>
                          </span>
                        }
                        @if (composeLines.moreLines) {
                          <span class="admin-import-module__line-source admin-import-module__line-more">
                            {{ 'TRANS__IMPORT__MAPPING__MORE_LINES' | translate: {count: composeLines.moreLines} }}
                          </span>
                        }
                      }
                    </div>
                  }
                }
              }
            </div>
          }

          </div>

          @if (store.genericBatchFields.length) {
            <div class="admin-import-module__target-section admin-import-module__batch" #batchBlock>
              <h6 class="admin-import-module__target-section-title">
                {{ 'TRANS__IMPORT__MAPPING__APPLIES_TO_ALL_ROWS' | translate }}
              </h6>
              <p class="admin-import-module__hint">
                {{ 'TRANS__IMPORT__BATCH_HINT' | translate }}
              </p>
              @if (store.loadingBatchFields) {
                <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
              }
              @for (field of store.genericBatchFields; track field.key) {
                <app-concept-picker
                  [label]="field.label"
                  [required]="field.required"
                  [options]="field.options"
                  [control]="store.batchControls[field.key]"
                ></app-concept-picker>
              }
            </div>
          }
        </mat-card>

        <mat-card appearance="outlined" class="admin-import-module__pane admin-import-module__preview-pane">
          <app-import-live-preview></app-import-live-preview>
        </mat-card>

      </div>
    }
  </div>
}
